import React from "react";
import { Truck, BadgePercent } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";

const PromoBanner = ({ compact = false }) => {
  const { settings } = useTheme();
  const text = settings?.commerce?.promo_banner_text || "";
  if (!text) return null;
  return (
    <div
      data-testid="promo-banner"
      className={`relative w-full overflow-hidden ${
        compact ? "py-2" : "py-3"
      } bg-gradient-to-r from-[#0D1426] via-[#13203E] to-[#0D1426] border-y border-[#C0C0C0]/20`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-center">
        <BadgePercent className="w-4 h-4 text-[#C0C0C0] shrink-0" strokeWidth={1.5} />
        <span data-testid="promo-banner-text" className="text-[11px] sm:text-[12px] tracking-[0.18em] uppercase text-[#E5E4E2]">
          {text}
        </span>
        <Truck className="w-4 h-4 text-[#C0C0C0] shrink-0" strokeWidth={1.5} />
      </div>
    </div>
  );
};

export default PromoBanner;
